import { createFileRoute, redirect } from '@tanstack/react-router'
import { BudgetsPage } from '../pages/BudgetsPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/budgets' as any)({
    component: BudgetsPage,
    beforeLoad: () => {
        const { isAuthenticated } = useAuthStore.getState()
        if (!isAuthenticated) {
            throw redirect({
                to: '/login',
            })
        }
    },
})
